module.exports = __webpack_public_path__ + "static/32invgde-4562bc9ab7c05322ccdcbb2ddb603a64.gif";